import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { Spin } from "antd";
import queryString from "query-string";

import { MainLayout } from "../../../components/Layout";
import { doGetProfile } from "../stores/thunk";
import { doGroupGetDetailCode } from "../../group/stores/thunk";
import { setRedirectUrl, setInviteCode } from "../stores/slice";
import { SetupAccountPage } from "../../../components/Pages";
import { hexToRgbWithOpacity } from "../../../utils/color";

class Container extends Component {
  componentDidMount() {
    const {
      doGetProfile,
      auth,
      setRedirectUrl,
      setInviteCode,
      location: { search, pathname },
      doGroupGetDetailCode,
    } = this.props;

    const query = queryString.parse(search);
    const redirectUrl = pathname + search;
    const invite = redirectUrl.indexOf("/groups/invite") > -1 ? query : null;

    if (invite?.code) {
      doGroupGetDetailCode(invite?.code);
      setInviteCode(invite?.code);
    }

    if (auth && !auth.authenticated) {
      setRedirectUrl(redirectUrl);
    }

    if (auth && auth.authenticated && !auth.user) {
      doGetProfile();
    }
  }

  render() {
    const {
      common,
      auth,
      component: Comp,
      actionDetailCode,
      isFetchingDetailCode,
      location: { search, pathname },
      ...props
    } = this.props;
    const query = queryString.parse(search);
    const redirectUrl = pathname + search;
    const invite = redirectUrl.indexOf("/groups/invite") > -1 ? query : null;

    if (actionDetailCode === "DetailCode" && isFetchingDetailCode)
      return <Spin style={{ paddingTop: 100, width: "100%" }} />;

    if (auth && auth.authenticated && !auth.user && common.error.statusCode != 401)
      return <Spin style={{ paddingTop: 100, width: "100%" }} />;
    if (auth && auth.authenticated && common.error.statusCode === 401) {
      return <Redirect to={{ pathname: "/logout" }} />;
    }

    const user = auth.user;
    const company = user?.company;
    const roles = user?.roles || [];
    const setupAccount = company?.name && company?.industry && company?.numOfDrivers;

    let primaryColor = "#7732EF";
    if (window.location.origin.includes("nordicrouting.se")) {
      primaryColor = "#009CFF";
      const primaryColorOpacityRgb = hexToRgbWithOpacity(primaryColor, 0.24);
      document.documentElement.style.setProperty("--primary-color", primaryColor);
      document.documentElement.style.setProperty("--primary-color-opacity", primaryColorOpacityRgb);
    }

    if (company) {
      const primaryColorOpacityRgb = hexToRgbWithOpacity(company?.primaryColor || primaryColor, 0.24);

      document.documentElement.style.setProperty("--primary-color", company?.primaryColor || primaryColor);
      document.documentElement.style.setProperty("--primary-color-opacity", primaryColorOpacityRgb);
    }

    if (roles.length > 0 && roles.includes("partner")) {
      if (redirectUrl === null || redirectUrl === "/") {
        return <Redirect to="/partner/companies" />;
      }
    }

    return (
      <Route
        {...props}
        render={p =>
          auth && auth.authenticated ? (
            roles.includes("company_admin") && !setupAccount ? (
              <SetupAccountPage user={user} />
            ) : (
              Comp && (
                <MainLayout {...this.props}>
                  <Comp {...p} />
                </MainLayout>
              )
            )
          ) : (
            <Redirect
              to={{
                pathname: invite?.code ? (invite?.user === "true" ? "/login" : "/register") : "/login",
                state: { from: p.location },
              }}
            />
          )
        }
      />
    );
  }
}

export default connect(
  state => ({
    common: state.common,
    auth: state.auth,
    isFetchingDetailCode: state.group.isFetching,
    actionDetailCode: state.group.action,
  }),
  {
    doGetProfile,
    setRedirectUrl,
    setInviteCode,
    doGroupGetDetailCode,
  },
)(Container);
